import React, { ReactNode } from 'react';
type FormFieldProps = {
  id: string;
  label: string;
  optional?: boolean;
  error?: string;
  className?: string;
  children: ReactNode;
};
export const inputClassName = 'block w-full rounded-md border border-line bg-surface px-3.5 py-2.5 text-base text-ink placeholder:text-muted/60 transition-colors duration-150 focus:border-ink focus:outline-none focus:ring-2 focus:ring-ink/10 aria-[invalid=true]:border-danger';
export function FormField({
  id,
  label,
  optional,
  error,
  className = '',
  children
}: FormFieldProps) {
  return <div className={className} data-id="element-134" data-mp="2f9ruf8957dmj">
      <label htmlFor={id} className="mb-1.5 flex items-baseline justify-between text-sm font-medium text-ink" data-id="element-135" data-mp="2t30yqui8h8y7">
        {label}
        {optional && <span className="text-xs font-normal text-muted" data-id="element-136" data-mp="2p27dya038a9j">Optional</span>}
      </label>
      {children}
      {error && <p id={`${id}-error`} className="mt-1.5 text-sm text-danger" data-id="element-137" data-mp="32zcgw14i8t0k">
          {error}
        </p>}
    </div>;
}